<ng-container *ngIf="!isLoginOrCallbackRoute()">
    <app-nav></app-nav>
  </ng-container>
  
  <router-outlet></router-outlet>
  
  <ng-container *ngIf="!isLoginOrCallbackRoute()">
    <app-footer></app-footer>
  </ng-container>